<template>
  <div>
    <div v-if="showTop" class="text-xs-center mb-2">
      <v-progress-linear v-if="loading" :indeterminate="true" :height="2"></v-progress-linear>
      <v-pagination
        v-else
        v-model="page"
        :length="pagelength"
        :total-visible="7"
        @input="changepage"
      ></v-pagination>
    </div>

    <slot></slot>

    <div v-if="showBottom" class="text-xs-center mt-2">
      <v-progress-linear v-if="loading" :indeterminate="true" :height="2"></v-progress-linear>
      <v-pagination
        v-else
        v-model="page"
        :length="pagelength"
        :total-visible="7"
        @input="changepage"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: 1
    },
    total: {
      default: 1
    },
    limit: {
      default: 10
    },
    loading: {
      default: false
    },
    showTop: {
      default: true
    },
    showBottom: {
      default: true
    }
  },
  data() {
    return {
      pagetmp: '',
      offset: 1,
      page: this.value
    }
  },
  computed: {
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  methods: {
    changepage(val) {
      this.$emit('input', this.page)
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.offset = this.page * this.limit - this.limit
        if (this.page != 1) {
          this.offset + 1
        }
        this.$emit('onChange', { limit: this.limit, offset: this.offset, page: val })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/Pagination2.vue